import styled from '@emotion/styled'

export const StyledSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 25px;
    background-color: ${({theme})=> theme.colors.section_color};
    border-radius: 15px;
    overflow: auto;
`